// ────────────────────────────────────────────────────────────────────────────
// COMMISSION & RESTE-À-PAYER PROSPACE — logique métier pure (testable).
// Extrait du repository (libs/data-access) pour respecter la règle CLAUDE.md :
// aucune logique métier dans les repositories. Le repository ne fait plus que
// résoudre les coûts (accès DB) puis appeler ces fonctions.
// ────────────────────────────────────────────────────────────────────────────

import { calculateSalesLineBenefit, type SalesBenefitLineInput } from './calculate-benefit';

function round3(n: number): number {
  return Math.round(n * 1000) / 1000;
}

/**
 * Commission ProSpace = somme, sur les lignes à marge POSITIVE, de
 * `marge × taux / 100`. La marge ligne provient de la source unique
 * `calculateSalesLineBenefit` (coût net snapshot, sinon catalogue). Une ligne à
 * marge nulle/négative ou à coût inconnu ne génère aucune commission — on ne
 * surévalue jamais la commission faute de coût.
 */
export function calculateProCommission(
  lines: SalesBenefitLineInput[],
  commissionRate: number,
): number {
  const rate = Number.isFinite(commissionRate) ? commissionRate : 0;
  const total = lines.reduce((sum, line) => {
    const { benefit } = calculateSalesLineBenefit(line);
    return benefit > 0 ? sum + (benefit * rate) / 100 : sum;
  }, 0);
  return round3(total);
}

/**
 * Reste à payer sur une commande ProSpace après imputation du portefeuille déjà
 * consommé. Jamais négatif :
 *   àPayer = max(0, totalTTC + fraisLivraison − déjàConsommé)
 */
export function computeProAmountDue(
  totalTtc: number,
  deliveryFee: number,
  totalUsed: number,
): number {
  const due = (Number(totalTtc) || 0) + (Number(deliveryFee) || 0) - (Number(totalUsed) || 0);
  return round3(Math.max(0, due));
}
